export default __webpack_public_path__ + "static/PublicaSans-Medium-3e9e0ca4440d9dd3b42241a1fd853c82.woff";